import idb from "@/plugins/indexdb.js";
import ArticlesRepo from "../../repositories/articles";

export default {
  namespaced: true,
  state: {
    articles: [],
    status: {}
  },
  mutations: {
    SET_PENDING_STATUS(state) {
      state.status = { isPending: true };
    },

    SET_SUCCESSFULL_STATUS(state, articles) {
      state.status = { isSuccess: true };
      state.articles = articles;
    },

    SET_FAILURE_STATUS(state) {
      state.status = { isFailure: true };
      state.articles = null;
    }
  },
  actions: {
    // Get all articles from api
    async getArticles({ commit }) {
      try {
        commit("SET_PENDING_STATUS");

        // Get articles array from API
        const { data } = await ArticlesRepo.get();

        // Clear articles table
        await idb.db.articles.clear();

        // Adds all articles in articles table
        await idb.db.articles.bulkAdd(data);

        commit("SET_SUCCESSFULL_STATUS", data);
      } catch (error) {
        commit("SET_FAILURE_STATUS");
        throw error;
      }
    },

    // Get all articles from IndexedDB
    async getLocalArticles() {
      try {
        const res = await idb.db.projects.toArray();
        return res;
      } catch (error) {
        throw error;
      }
    },

    // Get local articles from IndexedDB
    async getLocalArticle(context, article_id) {
      try {
        const res = await idb.db.articles.get(article_id);
        return res;
      } catch (error) {
        throw error;
      }
    },

    // Get local articles from IndexedDB
    async getLocalArticlesByModel(context, model) {
      try {
        const res = await idb.db.articles
          .where({ product_model: model })
          .toArray();

        return res.sort((a, b) => {
          if (a.order) {
            a.order - b.order;
          }
        });
      } catch (error) {
        throw error;
      }
    },

    // Clean store
    cleanArticles({ commit }) {
      commit("SET_SUCCESSFULL_STATUS", []);
    }
  }
};
